var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiNaverStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NAVER Store") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.57,0H.43A.43.43,0,0,0,0,.43H0V22.57A.43.43,0,0,0,.43,23H22.57a.43.43,0,0,0,.43-.43V.43A.43.43,0,0,0,22.57,0h0M5.78,5.62V2.68A.65.65,0,0,1,6.39,2a.66.66,0,0,1,.69.62v3a4.42,4.42,0,0,0,8.84,0V2.68a.65.65,0,0,1,1.3,0V5.62a5.73,5.73,0,0,1-11.45,0m14.7,15.05H19l-2.53-3.1v3.1h-1.7V15.44h1.48l2.52,3.16V15.44h1.71Z",
    className: "icon-path"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiNaverStore);
export default __webpack_public_path__ + "static/media/bi-naver-store.9be02fd5ccb9c825cb9a8f9b8198d3cd.svg";
export { ForwardRef as ReactComponent };